export enum TicketType {
    SUPPORT = 'SUPPORT',
    COMPLAINT = 'COMPLAINT',
}

export enum TicketStatus {
    // Support ticket statuses
    PENDING = 'PENDING',
    ACTIVE = 'ACTIVE',
    DONE = 'DONE',
    CANCELLED = 'CANCELLED',
    
    // Complaint ticket statuses
    CAN_DOI_CHIEU = 'CẦN ĐỐI CHIẾU',
    DA_DOI_CHIEU = 'ĐÃ ĐỐI CHIẾU',
    REPORTED = 'REPORTED',
    CORRECTING = 'CORRECTING',
    NGHIEM_THU = 'NGHIỆM THU',
    AUTOPSY = 'AUTOPSY',
    THOA_HIEP = 'THOẢ HIỆP',
    SOLVED = 'SOLVED',
}

export const TICKET_TYPE_CONFIG = {
    [TicketType.SUPPORT]: {
        label: 'Hỗ trợ',
        cssClass: 'text-sm !bg-blue-100 !text-blue-800 !border-blue-200'
    },
    [TicketType.COMPLAINT]: {
        label: 'Khiếu nại',
        cssClass: 'text-sm !bg-red-100 !text-red-800 !border-red-200'
    }
};

export const TICKET_STATUS_CONFIG = {
    [TicketStatus.PENDING]: {
        label: 'Chờ xử lý',
        cssClass: 'text-sm !bg-yellow-100 !text-yellow-800 !border-yellow-200'
    },
    [TicketStatus.ACTIVE]: {
        label: 'Đang xử lý',
        cssClass: 'text-sm !bg-blue-100 !text-blue-800 !border-blue-200'
    },
    [TicketStatus.DONE]: {
        label: 'Hoàn thành',
        cssClass: 'text-sm !bg-green-100 !text-green-800 !border-green-200'
    },
    [TicketStatus.CANCELLED]: {
        label: 'Đã hủy',
        cssClass: 'text-sm !bg-gray-100 !text-gray-800 !border-gray-200'
    },
    [TicketStatus.CAN_DOI_CHIEU]: {
        label: 'Cần đối chiếu',
        cssClass: 'text-sm !bg-orange-100 !text-orange-800 !border-orange-200'
    },
    [TicketStatus.DA_DOI_CHIEU]: {
        label: 'Đã đối chiếu',
        cssClass: 'text-sm !bg-purple-100 !text-purple-800 !border-purple-200'
    },
    [TicketStatus.REPORTED]: {
        label: 'Đã báo cáo',
        cssClass: 'text-sm !bg-red-100 !text-red-800 !border-red-200'
    },
    [TicketStatus.CORRECTING]: {
        label: 'Đang sửa',
        cssClass: 'text-sm !bg-yellow-100 !text-yellow-800 !border-yellow-200'
    },
    [TicketStatus.NGHIEM_THU]: {
        label: 'Nghiệm thu',
        cssClass: 'text-sm !bg-indigo-100 !text-indigo-800 !border-indigo-200'
    },
    [TicketStatus.AUTOPSY]: {
        label: 'Autopsy',
        cssClass: 'text-sm !bg-pink-100 !text-pink-800 !border-pink-200'
    },
    [TicketStatus.THOA_HIEP]: {
        label: 'Thoả hiệp',
        cssClass: 'text-sm !bg-teal-100 !text-teal-800 !border-teal-200'
    },
    [TicketStatus.SOLVED]: {
        label: 'Đã giải quyết',
        cssClass: 'text-sm !bg-green-100 !text-green-800 !border-green-200'
    }
};

export const TICKET_TYPE_OPTIONS = Object.entries(TICKET_TYPE_CONFIG).map(([key, value]) => ({
    label: value.label,
    value: key,
    cssClass: value.cssClass
}));

export const TICKET_STATUS_OPTIONS = Object.entries(TICKET_STATUS_CONFIG).map(([key, value]) => ({
    label: value.label,
    value: key,
    cssClass: value.cssClass
}));

